import styled from 'styled-components'

export const ForgotLink = styled.a`
    margin-top: 32px;

    font-size: 14px;

    &, &:active, &:visited, &:focus {
        text-decoration: none;
        color: ${p => p.theme.colors.accent};
    }

    cursor: pointer;
`

export const Social = styled.div`
    display: flex;
    margin-top: 32px;
`

export const SocialLogin = styled.img`
    /* width: 40px; */
    height: 40px;
    margin: 0 10px;

    cursor: pointer;
`